module.exports = __webpack_public_path__ + "img/Profil_CS-Lite_Volume.385b535a.jpg";